const trackingEvents = {
  events: [
    {
      eventName: "Click Nav Menu Item",
      properties: [
        { name: "menu_type" },
        { name: "page_path" },
        { name: "page_url" },
        { name: "nav_item" },
        { name: "destination_url" },
      ],
    },
    {
      eventName: "Click Log in",
      properties: [{ name: "page_url" }, { name: "page_path" }],
    },
    {
      eventName: "Click Get Started",
      properties: [{ name: "page_url" }, { name: "page_path" }],
    },
    {
      eventName: "Click Link",
      properties: [
        { name: "page_path" },
        { name: "page_url" },
        { name: "link_text" },
        { name: "destination_url" },
      ],
    },
    {
      eventName: "Click News Tile",
      properties: [
        { name: "news_article_title" },
        { name: "news_article_category" },
        { name: "news_article_publish_date" },
        { name: "page_path" },
        { name: "page_url" },
        { name: "position" },
        { name: "destination_url" },
      ],
    },
    {
      eventName: "Click Rolex Icon",
      properties: [{ name: "page_path" }, { name: "page_url" }],
    },
    {
      eventName: "Save Job Preferences",
      properties: [
        { name: "job_search_status" },
        { name: "job_recommendations" },
        { name: "job_type_sought" },
        { name: "job_minimum_comp" },
        { name: "job_locations" },
        { name: "job_interested_in_international" },
        { name: "job_open_to_seasonal" },
      ],
    },
    {
      eventName: "Click Job Tile",
      properties: [
        { name: "page_url" },
        { name: "page_path" },
        { name: "job_title" },
        { name: "job_company" },
        { name: "job_location" },
        { name: "job_post_date" },
        { name: "job_max_salary" },
        { name: "job_hourly_rate_range" },
        { name: "job_position_type" },
        { name: "job_recommended" },
        { name: "job_pga_pro_only" },
      ],
    },
    {
      eventName: "Click View All Recommended Jobs",
      properties: [{ name: "page_url" }, { name: "page_path" }],
    },
    {
      eventName: "Click Search for Jobs",
      properties: [
        { name: "page_url" },
        { name: "page_path" },
        { name: "job_keyword" },
      ],
    },
    {
      eventName: "Click Advanced Search",
      properties: [{ name: "page_url" }, { name: "page_path" }],
    },
    {
      eventName: "View Job Search Results",
      properties: [
        { name: "job_search_keyword" },
        { name: "job_search_city" },
        { name: "job_search_recommended_only" },
        { name: "job_search_job_class" },
        { name: "job_search_job_type" },
        { name: "job_search_job_category" },
        { name: "job_search_section" },
        { name: "job_search_results_count" },
      ],
    },
    {
      eventName: "View Job",
      properties: [
        { name: "job_id" },
        { name: "page_url" },
        { name: "page_path" },
        { name: "job_title" },
        { name: "job_company" },
        { name: "job_location" },
        { name: "job_post_date" },
        { name: "job_max_salary" },
        { name: "job_hourly_rate_range" },
        { name: "job_position_type" },
        { name: "job_recommended" },
        { name: "job_pga_logo" },
        { name: "job_deadline" },
        { name: "job_minimum_experience" },
        { name: "job_education_required" },
        { name: "job_additional_pga_education" },
        { name: "job_section" },
      ],
    },
    {
      eventName: "Submit Job Application",
      properties: [
        { name: "job_id" },
        { name: "page_url" },
        { name: "page_path" },
        { name: "job_title" },
        { name: "job_company" },
        { name: "job_location" },
        { name: "job_post_date" },
        { name: "job_max_salary" },
        { name: "job_hourly_rate_range" },
        { name: "job_position_type" },
        { name: "job_recommended" },
        { name: "job_pga_logo" },
        { name: "job_deadline" },
        { name: "job_minimum_experience" },
        { name: "job_education_required" },
        { name: "job_additional_pga_education" },
        { name: "job_section" },
      ],
    },
    {
      eventName: "Search Directory",
      properties: [
        { name: "directory_search_query" },
        { name: "directory_search_location" },
        { name: "directory_search_member_type" },
        { name: "directory_search_member_certification" },
        { name: "directory_search_facility_type" },
        { name: "directory_search_sections" },
      ],
    },
    {
      eventName: "View News Category Page",
      properties: [{ name: "news_category" }],
    },
    {
      eventName: "View News Article",
      properties: [
        { name: "page_path" },
        { name: "page_url" },
        { name: "news_article_title" },
        { name: "news_article_publish_date" },
        { name: "news_article_category" },
      ],
    },
    {
      eventName: "Search PGA Events",
      properties: [
        { name: "event_search_query" },
        { name: "event_search_refinements" },
        { name: "event_search_results_returned" },
      ],
    },
    {
      eventName: "Click Event Tile",
      properties: [
        { name: "event_title" },
        { name: "event_start_date" },
        { name: "event_end_date" },
        { name: "event_location" },
        { name: "page_path" },
        { name: "page_url" },
      ],
    },
    {
      eventName: "View Event Page",
      properties: [
        { name: "event_title" },
        { name: "event_program_number" },
        { name: "event_start_date" },
        { name: "event_end_date" },
        { name: "event_location" },
        { name: "event_type" },
        { name: "event_eligible_to_play" },
        { name: "event_registration_deadline" },
        { name: "event_registration_status" },
        { name: "page_path" },
        { name: "page_url" },
      ],
    },
    {
      eventName: "Click Register for Event",
      properties: [
        { name: "page_path" },
        { name: "page_url" },
        { name: "event_name" },
        { name: "destination_url" },
      ],
    },
    {
      eventName: "Search resources",
      properties: [
        { name: "resource_search_query" },
        { name: "page_path" },
        { name: "page_view" },
      ],
    },
    {
      eventName: "View Resources Search Results",
      properties: [
        { name: "page_path" },
        { name: "page_view" },
        { name: "resources_search_query" },
        { name: "resources_number_of_search_results" },
      ],
    },
    {
      eventName: "Click Resources Search Result",
      properties: [
        { name: "resources_search_result_type" },
        { name: "resources_search_result_category" },
        { name: "resources_search_result_title" },
        { name: "destination_url" },
        { name: "page_path" },
        { name: "page_url" },
      ],
    },
  ],
}

export default trackingEvents
